import React, {  } from 'react';

import { SbCurrentUser } from '../submission_boards/component/SbModel';
import MediaKitsPagev1 from './MediaKitsPagev1';
import MediaKitsPagev2 from './MediaKitsPagev2';
export interface MediaKitsPageProps {
  currentUser: SbCurrentUser;
}
export default function MediaKitsPage({ currentUser }: MediaKitsPageProps) {
  const version:number = 2;
   return (
     <>
       {version == 1 && (
         <>
           <MediaKitsPagev1 currentUser={currentUser} />
         </>
       )}
       {version == 2 && (
         <>
           <MediaKitsPagev2 currentUser={currentUser} />
         </>
       )}
     </>
   );
}
